import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgMobileWidget = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 42,
	height: 32,
	viewBox: "0 0 42 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			id: "b",
			d: "M14.509 5.364A2.37 2.37 0 0 1 16.872 3H28.69a2.37 2.37 0 0 1 2.364 2.364v21.272A2.37 2.37 0 0 1 28.69 29H16.872a2.37 2.37 0 0 1-2.363-2.364v-3.545h2.363v2.364H28.69V6.545H16.872V8.91H14.51V5.364zm2.954 14.772l-.2 1.277a.576.576 0 0 1-.58.496h-1.985a.577.577 0 0 1-.58-.508l-.2-1.265a4.272 4.272 0 0 1-.946-.567l.012.047-1.194.461a.59.59 0 0 1-.72-.26l-.993-1.725a.599.599 0 0 1 .142-.757l1.004-.803.024.035c-.024-.189-.06-.378-.06-.567 0-.19.036-.378.06-.555l-.024.035-1.004-.804a.599.599 0 0 1-.142-.756l.992-1.725a.576.576 0 0 1 .721-.26l1.206.46-.024.036c.296-.225.603-.426.946-.567l.2-1.277a.576.576 0 0 1 .58-.496h1.985c.296 0 .544.213.58.496l.2 1.277c.343.141.65.342.946.543l-.024-.035 1.194-.461a.59.59 0 0 1 .72.26l.993 1.725a.599.599 0 0 1-.142.757l-1.004.803-.024-.035c.024.189.06.378.06.567 0 .19-.036.378-.06.567l.024-.035 1.004.804a.599.599 0 0 1 .142.756l-.993 1.725a.576.576 0 0 1-.72.26l-1.194-.46.024-.036a4.272 4.272 0 0 1-.946.567zM13.327 16a2.37 2.37 0 0 0 2.363 2.364A2.37 2.37 0 0 0 18.054 16a2.37 2.37 0 0 0-2.364-2.364A2.37 2.37 0 0 0 13.327 16z"
		})
	})
});
export default SvgMobileWidget;
